module.exports = __webpack_public_path__ + "img/statementbg2.c0608a4f.jpg";